var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.products.length),expression:"products.length"}],staticClass:"category-favorite"},[_c('product-carousel',{attrs:{"classes":_vm.classes,"items":_vm.products}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }